import { isMobile, getElementHeight, _t } from './base'

export function handleFreeShipping() {
    const { leftToFreeShipping } = getShoptetDataLayer('cartInfo')
    const isFreeShipping = leftToFreeShipping.priceLeft <= 0

    if (isFreeShipping) {
        $('.extra.delivery').addClass('shipping-is-free')
        $('.cart-free-shipping').addClass('shipping-is-free')
    }
}

function createAdvancedOrderProductTemplate(image, price, name, url, availability) {
    return /* HTML */ `
        <div class="advanced-order-product">
            ${url ? `<a href="${url}" class="advanced-order-image">` : '<div class="advanced-order-image">'}
            <img src="${image}" alt="${name}" />
            ${url ? '</a>' : '</div>'}
            <div class="advanced-order-name">
                ${url ? `<a href="${url}">` : ''}
                <div class="advanced-order-name__text">${name}</div>
                <div class="advanced-order-availability">${availability}</div>
                ${url ? '</a>' : ''}
                <div class="advanced-order-price">${price}</div>
            </div>
        </div>
    `
}
export function createAdvancedOrderProduct(options) {
    const handleAdvancedOrderLoaded = () => {
        const { image, price, url, availability } = options
        const name = $(".h2[data-testid='textPopupProductName']").text()

        const advancedOrderProductHtml = createAdvancedOrderProductTemplate(
            image,
            price,
            name,
            url,
            availability
        )

        $('.advanced-order-product').remove()
        $(advancedOrderProductHtml).insertBefore('.extras-wrap')
    }

    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', handleAdvancedOrderLoaded, { once: true })
}

function addScrollPadding() {
    const offset = 20
    const headerHeight =
        getElementHeight('.top-navigation-bar') +
        getElementHeight('.header-top') +
        getElementHeight('.header-bottom') +
        getElementHeight('.site-msg.information')

    document.documentElement.style.setProperty('--scroll-padding', `${headerHeight + offset}px`)
}

function emptyCart() {
    setTimeout(() => {
        const cart = getShoptetDataLayer('cart')
        const btn = `<a href="/" class = "btn btn-primary">${_t('emptyCart.backToShop')}</a>`
        const title = `<h2 class="h1 cart-heading" data-testid="cartTitle">${_t('emptyCart.title')}</h2>`
        const cartWidgetInner = $('.cart-widget-inner')
        const cartContent = $('.col-md-8 .cart-content')

        if (!cart.length) {
            $('body').addClass('cart-is-empty')
            if (!isMobile() && $('.cart-empty').length) {
                // desktop
                cartContent.append($('.cart-heading'), btn)
            } else {
                // mobile
                $('.cart-widget').addClass('cart-is-empty')
                cartWidgetInner.append(title, btn)
            }
        } else {
            $('.cart-widget').removeClass('cart-is-empty')
        }

        $('#content-wrapper .cart-wrapper').addClass('ready')
    }, 200)
}

export function initGlobalFunctions() {
    setTimeout(addScrollPadding, 500)
    emptyCart()
    document.addEventListener('ShoptetDOMCartContentLoaded', () => {
        emptyCart()
    })
}
